import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { languages } from 'i18n/options';

/*
 * Converts a language string to a language code.
 * If an exact match is found then the language code is returned.
 * If a fuzzy match is found then the language code is returned with a % suffix.
 * If no match is found then the original string is returned with a % suffix.
 */
export default function languageCodeMap(str) {
  str = str.replace(/^(")?(.*)\1$/, '$2').toLowerCase();
  var lang = languages.find(function (l) {
    return l.title_en.replace(/\s+/g, '').toLowerCase().indexOf(str) === 0 || l.title.replace(/\s+/g, '').toLowerCase().indexOf(str) === 0;
  });
  if (lang && (str === lang.value || str === lang.title.replace(/\s+/g, '').toLowerCase() || str === lang.title_en.replace(/\s+/g, '').toLowerCase())) {
    return lang.value;
  } else if (lang) {
    return "".concat(lang.value, "%");
  } else {
    return "".concat(str, "%");
  }
}